import { render } from "./Intro.vue?vue&type=template&id=27921c0e&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=27921c0e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27921c0e"

export default script